module.exports = __webpack_public_path__ + "img/project-addpages.jpg?7cd7a0c023c0396277734a1e1876ce05";